module.exports = "/static/images/groups.jpg";